
import React, { Component } from 'react';

//import Game from './game/Game';

import './../../../scss/App.scss';


class InfoBox extends Component {

	constructor(props){
		super(props);

		this.state = {
			"question": "",
			"number": "",
			"direction": "",
			"showClearBtn": false,
			"showNoErrorsMsg": false
		}

		//

		this.updateInfo = this.updateInfo.bind(this);
		this.handleClear = this.handleClear.bind(this);
		this.handleCheckPuzzle = this.handleCheckPuzzle.bind(this);

		//

		window.ppz.infoBox = this;
	}

	componentDidMount(){

	}

	componentDidUpdate(prevProp, prevState) {
		// play sound if puzzle slot gains focus
		if(prevState.question !== this.state.question && this.state.question !== ""){
			window.sounds.reveal.play();
		}

		// if a new question appears, be sure to clear "no error" message from check btn and remove "clear" button
		if(prevState.question !== this.state.question){
			this.showNoErrorsMsg(false);
			this.showClearBtn(false);
		}
	}

	updateInfo(infoData){
		this.setState(infoData);
	}

	renderOptionsPanel(){
		return (
			<div className="optionsPanel">
				{/* <div className="clearBtn btn" onClick={() => window.ppz.crossword.handleClearBtn()}>Clear Puzzle</div>
				<div className="checkBtn btn" onClick={this.props.handleCheckBtn()}>Check Puzzle</div>
				<div className="revealLetterBtn btn" onClick={this.props.handleRevealLetter()}>Reveal Letter</div> */}
			</div>
		)
	}

	renderInfo(){
		//console.log("this.state.question: ", this.state.question);
		//console.log("this.state.number: ", this.state.number);
		//console.log("this.state.direction: ", this.state.direction);

		if(this.state.question === "" || this.state.number === "" || this.state.direction === ""){
			if(this.state.showNoErrorsMsg){
				return (
					<div className="infoContent">
						<div className="getStartedMsg">Nice job! No errors found!</div>
					</div>
				);
			}
			else {
				return (
					<div className="infoContent">
						<div className="getStartedMsg">Click on any tile to start!</div>
					</div>
				);
			}
		}
		else {
			return (
				<div className="infoContent">
					<div className="slotDetail">{this.state.number} {this.state.direction}</div>
					<div className="question">{this.state.question}</div>
				</div>
			)
		}
	}

	handleCheckPuzzle(){
		window.ppz.crossword.handleCheckBtn();
	}

	handleClear(){
		window.ppz.crossword.handleClearBtn();

		this.showClearBtn(false);
	}

	showClearBtn(bool){
		this.setState({
			"showClearBtn": bool
		});
	}

	showNoErrorsMsg(bool){
		this.setState({
			"showNoErrorsMsg": bool
		});
	}

	render(){

		let showClearBtn = "";

		if(this.state.showClearBtn){
			showClearBtn = " active";
		}

		return (
			<div className="infoBox">
				{this.props.hasWon ?
					<div>
						<div className="infoContent" style={{"textAlign": "center"}}>
							<div className="getStartedMsg">This puzzle has been completed!</div>
						</div>
						<div  style={{"textAlign": "center"}}>
							<div className="checkBtn" onClick={() => window.ppz.overlayManager.setPanel("puzzleSelect")}>PLAY ANOTHER PUZZLE</div>
						</div>
					</div>
				:
					<div>
						{this.renderInfo()}
						<div>
							<div className="checkBtn" onClick={() => this.handleCheckPuzzle()}>CHECK PUZZLE</div>
							<div className={"clearBtn" + showClearBtn} onClick={() => this.handleClear()}>CLEAR ERRORS</div>
						</div>
						<div className="helpBtn fa-solid fa-question" onClick={() => window.ppz.overlayManager.setPanel("instructions")}></div>
					</div>
				}	
			</div>
		);
	}
}

export default InfoBox;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/InfoBox.js